import { useContext, useMemo } from 'react';
import { ChannelContext, UserContext } from '../../context';
import { StorySection, StoryStatus, useStoriesByChannelIdQuery } from '../../services';
import { FeedFollowBehavior } from '../models';
import { isAdminLayout } from '../utils';

interface UseFollowableStoriesArgs {
  feedFollowedStatus?: boolean;
  feedFollowBehavior?: FeedFollowBehavior[];
}

export const useFollowableStories = ({
  feedFollowedStatus,
  feedFollowBehavior = [FeedFollowBehavior.OPTIONAL_FOLLOW, FeedFollowBehavior.OPTIONAL_UNFOLLOW],
}: UseFollowableStoriesArgs = {}) => {
  const { id: channelId } = useContext(ChannelContext).channel;

  const { isAnonymous } = useContext(UserContext).userProfile;

  const { data, isFetching } = useStoriesByChannelIdQuery(
    {
      channelId,
      filter: {
        section: [StorySection.WEB_FEED, StorySection.MOBILE_FEED],
        feedFollowedStatus,
        feedFollowBehavior,
        status: [StoryStatus.PUBLISHED],
      },
    },
    { skip: isAnonymous || isAdminLayout() }
  );

  return useMemo(
    () => ({ followableStories: data ?? [], isFetchingFollowableStories: isFetching }),
    [data, isFetching]
  );
};
